export default __webpack_public_path__ + "static/media/womenWinterClothes.2dee8edb.svg";